export const Countries = [
    {"label": "Mixed Countries", "iso": "AF", "flag": "🇦🇫", "value": "mixed"},
    {"label": "Afghanistan", "iso": "AF", "flag": "🇦🇫", "value": "+93"},
    {"label": "Aland Islands", "iso": "AX", "flag": "🇦🇽", "value": "+358-18"},
    {"label": "Albania", "iso": "AL", "flag": "🇦🇱", "value": "+355"},
    {"label": "Algeria", "iso": "DZ", "flag": "🇩🇿", "value": "+213"},
    {"label": "American Samoa", "iso": "AS", "flag": "🇦🇸", "value": "+1-684"},
    {"label": "Andorra", "iso": "AD", "flag": "🇦🇩", "value": "+376"},
    {"label": "Angola", "iso": "AO", "flag": "🇦🇴", "value": "+244"},
    {"label": "Anguilla", "iso": "AI", "flag": "🇦🇮", "value": "+1264"},
    {"label": "Antarctica", "iso": "AQ", "flag": "🇦🇶", "value": "+672"},
    {"label": "Antigua and Barbuda", "iso": "AG", "flag": "🇦🇬", "value": "+1-268"},
    {"label": "Argentina", "iso": "AR", "flag": "🇦🇷", "value": "+54"},
    {"label": "Armenia", "iso": "AM", "flag": "🇦🇲", "value": "+374"},
    {"label": "Aruba", "iso": "AW", "flag": "🇦🇼", "value": "+297"},
    {"label": "Australia", "iso": "AU", "flag": "🇦🇺", "value": "+61"},
    {"label": "Austria", "iso": "AT", "flag": "🇦🇹", "value": "+43"},
    {"label": "Azerbaijan", "iso": "AZ", "flag": "🇦🇿", "value": "+994"},
    {"label": "Bahamas", "iso": "BS", "flag": "🇧🇸", "value": "+1-242"},
    {"label": "Bahrain", "iso": "BH", "flag": "🇧🇭", "value": "+973"},
    {"label": "Bangladesh", "iso": "BD", "flag": "🇧🇩", "value": "+880"},
    {"label": "Barbados", "iso": "BB", "flag": "🇧🇧", "value": "+1-246"},
    {"label": "Belarus", "iso": "BY", "flag": "🇧🇾", "value": "+375"},
    {"label": "Belgium", "iso": "BE", "flag": "🇧🇪", "value": "+32"},
    {"label": "Belize", "iso": "BZ", "flag": "🇧🇿", "value": "+501"},
    {"label": "Benin", "iso": "BJ", "flag": "🇧🇯", "value": "+229"},
    {"label": "Bermuda", "iso": "BM", "flag": "🇧🇲", "value": "+1-441"},
    {"label": "Bhutan", "iso": "BT", "flag": "🇧🇹", "value": "+975"},
    {"label": "Bolivia", "iso": "BO", "flag": "🇧🇴", "value": "+591"},
    {"label": "Bonaire, Saint Eustatius and Saba ", "iso": "BQ", "flag": "🇧🇶", "value": "+599"},
    {"label": "Bosnia and Herzegovina", "iso": "BA", "flag": "🇧🇦", "value": "+387"},
    {"label": "Botswana", "iso": "BW", "flag": "🇧🇼", "value": "+267"},
    {"label": "Bouvet Island", "iso": "BV", "flag": "🇧🇻", "value": "+47"},
    {"label": "Brazil", "iso": "BR", "flag": "🇧🇷", "value": "+55"},
    {"label": "British Indian Ocean Territory", "iso": "IO", "flag": "🇮🇴", "value": "+246"},
    {"label": "British Virgin Islands", "iso": "VG", "flag": "🇻🇬", "value": "+1-284"},
    {"label": "Brunei", "iso": "BN", "flag": "🇧🇳", "value": "+673"},
    {"label": "Bulgaria", "iso": "BG", "flag": "🇧🇬", "value": "+359"},
    {"label": "Burkina Faso", "iso": "BF", "flag": "🇧🇫", "value": "+226"},
    {"label": "Burundi", "iso": "BI", "flag": "🇧🇮", "value": "+257"},
    {"label": "Cambodia", "iso": "KH", "flag": "🇰🇭", "value": "+855"},
    {"label": "Cameroon", "iso": "CM", "flag": "🇨🇲", "value": "+237"},
    {"label": "Canada", "iso": "CA", "flag": "🇨🇦", "value": "+1"},
    {"label": "Cape Verde", "iso": "CV", "flag": "🇨🇻", "value": "+238"},
    {"label": "Cayman Islands", "iso": "KY", "flag": "🇰🇾", "value": "+1-345"},
    {"label": "Central African Republic", "iso": "CF", "flag": "🇨🇫", "value": "+236"},
    {"label": "Chad", "iso": "TD", "flag": "🇹🇩", "value": "+235"},
    {"label": "Chile", "iso": "CL", "flag": "🇨🇱", "value": "+56"},
    {"label": "China", "iso": "CN", "flag": "🇨🇳", "value": "+86"},
    {"label": "Christmas Island", "iso": "CX", "flag": "🇨🇽", "value": "+61"},
    {"label": "Cocos Islands", "iso": "CC", "flag": "🇨🇨", "value": "+61"},
    {"label": "Colombia", "iso": "CO", "flag": "🇨🇴", "value": "+57"},
    {"label": "Comoros", "iso": "KM", "flag": "🇰🇲", "value": "+269"},
    {"label": "Cook Islands", "iso": "CK", "flag": "🇨🇰", "value": "+682"},
    {"label": "Costa Rica", "iso": "CR", "flag": "🇨🇷", "value": "+506"},
    {"label": "Croatia", "iso": "HR", "flag": "🇭🇷", "value": "+385"},
    {"label": "Cuba", "iso": "CU", "flag": "🇨🇺", "value": "+53"},
    {"label": "Curacao", "iso": "CW", "flag": "🇨🇼", "value": "+599"},
    {"label": "Cyprus", "iso": "CY", "flag": "🇨🇾", "value": "+357"},
    {"label": "Czech Republic", "iso": "CZ", "flag": "🇨🇿", "value": "+420"},
    {"label": "Democratic Republic of the Congo", "iso": "CD", "flag": "🇨🇩", "value": "+243"},
    {"label": "Denmark", "iso": "DK", "flag": "🇩🇰", "value": "+45"},
    {"label": "Djibouti", "iso": "DJ", "flag": "🇩🇯", "value": "+253"},
    {"label": "Dominica", "iso": "DM", "flag": "🇩🇲", "value": "+1-767"},
    {"label": "Dominican Republic", "iso": "DO", "flag": "🇩🇴", "value": "+1-809 and 1-829"},
    {"label": "East Timor", "iso": "TL", "flag": "🇹🇱", "value": "+670"},
    {"label": "Ecuador", "iso": "EC", "flag": "🇪🇨", "value": "+593"},
    {"label": "Egypt", "iso": "EG", "flag": "🇪🇬", "value": "+20"},
    {"label": "El Salvador", "iso": "SV", "flag": "🇸🇻", "value": "+503"},
    {"label": "Equatorial Guinea", "iso": "GQ", "flag": "🇬🇶", "value": "+240"},
    {"label": "Eritrea", "iso": "ER", "flag": "🇪🇷", "value": "+291"},
    {"label": "Estonia", "iso": "EE", "flag": "🇪🇪", "value": "+372"},
    {"label": "Ethiopia", "iso": "ET", "flag": "🇪🇹", "value": "+251"},
    {"label": "Falkland Islands", "iso": "FK", "flag": "🇫🇰", "value": "+500"},
    {"label": "Faroe Islands", "iso": "FO", "flag": "🇫🇴", "value": "+298"},
    {"label": "Fiji", "iso": "FJ", "flag": "🇫🇯", "value": "+679"},
    {"label": "Finland", "iso": "FI", "flag": "🇫🇮", "value": "+358"},
    {"label": "France", "iso": "FR", "flag": "🇫🇷", "value": "+33"},
    {"label": "French Guiana", "iso": "GF", "flag": "🇬🇫", "value": "+594"},
    {"label": "French Polynesia", "iso": "PF", "flag": "🇵🇫", "value": "+689"},
    {"label": "French Southern Territories", "iso": "TF", "flag": "🇹🇫", "value": "+262"},
    {"label": "Gabon", "iso": "GA", "flag": "🇬🇦", "value": "+241"},
    {"label": "Gambia", "iso": "GM", "flag": "🇬🇲", "value": "+220"},
    {"label": "Georgia", "iso": "GE", "flag": "🇬🇪", "value": "+995"},
    {"label": "Germany", "iso": "DE", "flag": "🇩🇪", "value": "+49"},
    {"label": "Ghana", "iso": "GH", "flag": "🇬🇭", "value": "+233"},
    {"label": "Gibraltar", "iso": "GI", "flag": "🇬🇮", "value": "+350"},
    {"label": "Greece", "iso": "GR", "flag": "🇬🇷", "value": "+30"},
    {"label": "Greenland", "iso": "GL", "flag": "🇬🇱", "value": "+299"},
    {"label": "Grenada", "iso": "GD", "flag": "🇬🇩", "value": "+1-473"},
    {"label": "Guadeloupe", "iso": "GP", "flag": "🇬🇵", "value": "+590"},
    {"label": "Guam", "iso": "GU", "flag": "🇬🇺", "value": "+1-671"},
    {"label": "Guatemala", "iso": "GT", "flag": "🇬🇹", "value": "+502"},
    {"label": "Guernsey", "iso": "GG", "flag": "🇬🇬", "value": "+44-1481"},
    {"label": "Guinea", "iso": "GN", "flag": "🇬🇳", "value": "+224"},
    {"label": "Guinea-Bissau", "iso": "GW", "flag": "🇬🇼", "value": "+245"},
    {"label": "Guyana", "iso": "GY", "flag": "🇬🇾", "value": "+592"},
    {"label": "Haiti", "iso": "HT", "flag": "🇭🇹", "value": "+509"},
    {"label": "Heard Island and McDonald Islands", "iso": "HM", "flag": "🇭🇲", "value": "+ "},
    {"label": "Honduras", "iso": "HN", "flag": "🇭🇳", "value": "+504"},
    {"label": "Hong Kong", "iso": "HK", "flag": "🇭🇰", "value": "+852"},
    {"label": "Hungary", "iso": "HU", "flag": "🇭🇺", "value": "+36"},
    {"label": "Iceland", "iso": "IS", "flag": "🇮🇸", "value": "+354"},
    {"label": "India", "iso": "IN", "flag": "🇮🇳", "value": "+91"},
    {"label": "Indonesia", "iso": "ID", "flag": "🇮🇩", "value": "+62"},
    {"label": "Iran", "iso": "IR", "flag": "🇮🇷", "value": "+98"},
    {"label": "Iraq", "iso": "IQ", "flag": "🇮🇶", "value": "+964"},
    {"label": "Ireland", "iso": "IE", "flag": "🇮🇪", "value": "+353"},
    {"label": "Isle of Man", "iso": "IM", "flag": "🇮🇲", "value": "+44-1624"},
    {"label": "Israel", "iso": "IL", "flag": "🇮🇱", "value": "+972"},
    {"label": "Italy", "iso": "IT", "flag": "🇮🇹", "value": "+39"},
    {"label": "Ivory Coast", "iso": "CI", "flag": "🇨🇮", "value": "+225"},
    {"label": "Jamaica", "iso": "JM", "flag": "🇯🇲", "value": "+1-876"},
    {"label": "Japan", "iso": "JP", "flag": "🇯🇵", "value": "+81"},
    {"label": "Jersey", "iso": "JE", "flag": "🇯🇪", "value": "+44-1534"},
    {"label": "Jordan", "iso": "JO", "flag": "🇯🇴", "value": "+962"},
    {"label": "Kazakhstan", "iso": "KZ", "flag": "🇰🇿", "value": "+7"},
    {"label": "Kenya", "iso": "KE", "flag": "🇰🇪", "value": "+254"},
    {"label": "Kiribati", "iso": "KI", "flag": "🇰🇮", "value": "+686"},
    {"label": "Kosovo", "iso": "XK", "flag": "🇽🇰", "value": "+383"},
    {"label": "Kuwait", "iso": "KW", "flag": "🇰🇼", "value": "+965"},
    {"label": "Kyrgyzstan", "iso": "KG", "flag": "🇰🇬", "value": "+996"},
    {"label": "Laos", "iso": "LA", "flag": "🇱🇦", "value": "+856"},
    {"label": "Latvia", "iso": "LV", "flag": "🇱🇻", "value": "+371"},
    {"label": "Lebanon", "iso": "LB", "flag": "🇱🇧", "value": "+961"},
    {"label": "Lesotho", "iso": "LS", "flag": "🇱🇸", "value": "+266"},
    {"label": "Liberia", "iso": "LR", "flag": "🇱🇷", "value": "+231"},
    {"label": "Libya", "iso": "LY", "flag": "🇱🇾", "value": "+218"},
    {"label": "Liechtenstein", "iso": "LI", "flag": "🇱🇮", "value": "+423"},
    {"label": "Lithuania", "iso": "LT", "flag": "🇱🇹", "value": "+370"},
    {"label": "Luxembourg", "iso": "LU", "flag": "🇱🇺", "value": "+352"},
    {"label": "Macao", "iso": "MO", "flag": "🇲🇴", "value": "+853"},
    {"label": "Macedonia", "iso": "MK", "flag": "🇲🇰", "value": "+389"},
    {"label": "Madagascar", "iso": "MG", "flag": "🇲🇬", "value": "+261"},
    {"label": "Malawi", "iso": "MW", "flag": "🇲🇼", "value": "+265"},
    {"label": "Malaysia", "iso": "MY", "flag": "🇲🇾", "value": "+60"},
    {"label": "Maldives", "iso": "MV", "flag": "🇲🇻", "value": "+960"},
    {"label": "Mali", "iso": "ML", "flag": "🇲🇱", "value": "+223"},
    {"label": "Malta", "iso": "MT", "flag": "🇲🇹", "value": "+356"},
    {"label": "Marshall Islands", "iso": "MH", "flag": "🇲🇭", "value": "+692"},
    {"label": "Martinique", "iso": "MQ", "flag": "🇲🇶", "value": "+596"},
    {"label": "Mauritania", "iso": "MR", "flag": "🇲🇷", "value": "+222"},
    {"label": "Mauritius", "iso": "MU", "flag": "🇲🇺", "value": "+230"},
    {"label": "Mayotte", "iso": "YT", "flag": "🇾🇹", "value": "+262"},
    {"label": "Mexico", "iso": "MX", "flag": "🇲🇽", "value": "+52"},
    {"label": "Micronesia", "iso": "FM", "flag": "🇫🇲", "value": "+691"},
    {"label": "Moldova", "iso": "MD", "flag": "🇲🇩", "value": "+373"},
    {"label": "Monaco", "iso": "MC", "flag": "🇲🇨", "value": "+377"},
    {"label": "Mongolia", "iso": "MN", "flag": "🇲🇳", "value": "+976"},
    {"label": "Montenegro", "iso": "ME", "flag": "🇲🇪", "value": "+382"},
    {"label": "Montserrat", "iso": "MS", "flag": "🇲🇸", "value": "+1-664"},
    {"label": "Morocco", "iso": "MA", "flag": "🇲🇦", "value": "+212"},
    {"label": "Mozambique", "iso": "MZ", "flag": "🇲🇿", "value": "+258"},
    {"label": "Myanmar", "iso": "MM", "flag": "🇲🇲", "value": "+95"},
    {"label": "Namibia", "iso": "NA", "flag": "🇳🇦", "value": "+264"},
    {"label": "Nauru", "iso": "NR", "flag": "🇳🇷", "value": "+674"},
    {"label": "Nepal", "iso": "NP", "flag": "🇳🇵", "value": "+977"},
    {"label": "Netherlands", "iso": "NL", "flag": "🇳🇱", "value": "+31"},
    {"label": "New Caledonia", "iso": "NC", "flag": "🇳🇨", "value": "+687"},
    {"label": "New Zealand", "iso": "NZ", "flag": "🇳🇿", "value": "+64"},
    {"label": "Nicaragua", "iso": "NI", "flag": "🇳🇮", "value": "+505"},
    {"label": "Niger", "iso": "NE", "flag": "🇳🇪", "value": "+227"},
    {"label": "Nigeria", "iso": "NG", "flag": "🇳🇬", "value": "+234"},
    {"label": "Niue", "iso": "NU", "flag": "🇳🇺", "value": "+683"},
    {"label": "Norfolk Island", "iso": "NF", "flag": "🇳🇫", "value": "+672"},
    {"label": "North Korea", "iso": "KP", "flag": "🇰🇵", "value": "+850"},
    {"label": "Northern Mariana Islands", "iso": "MP", "flag": "🇲🇵", "value": "+1-670"},
    {"label": "Norway", "iso": "NO", "flag": "🇳🇴", "value": "+47"},
    {"label": "Oman", "iso": "OM", "flag": "🇴🇲", "value": "+968"},
    {"label": "Pakistan", "iso": "PK", "flag": "🇵🇰", "value": "+92"},
    {"label": "Palau", "iso": "PW", "flag": "🇵🇼", "value": "+680"},
    {"label": "Palestinian Territory", "iso": "PS", "flag": "🇵🇸", "value": "+970"},
    {"label": "Panama", "iso": "PA", "flag": "🇵🇦", "value": "+507"},
    {"label": "Papua New Guinea", "iso": "PG", "flag": "🇵🇬", "value": "+675"},
    {"label": "Paraguay", "iso": "PY", "flag": "🇵🇾", "value": "+595"},
    {"label": "Peru", "iso": "PE", "flag": "🇵🇪", "value": "+51"},
    {"label": "Philippines", "iso": "PH", "flag": "🇵🇭", "value": "+63"},
    {"label": "Pitcairn", "iso": "PN", "flag": "🇵🇳", "value": "+870"},
    {"label": "Poland", "iso": "PL", "flag": "🇵🇱", "value": "+48"},
    {"label": "Portugal", "iso": "PT", "flag": "🇵🇹", "value": "+351"},
    {"label": "Puerto Rico", "iso": "PR", "flag": "🇵🇷", "value": "+1-787 and 1-939"},
    {"label": "Qatar", "iso": "QA", "flag": "🇶🇦", "value": "+974"},
    {"label": "Republic of the Congo", "iso": "CG", "flag": "🇨🇬", "value": "+242"},
    {"label": "Reunion", "iso": "RE", "flag": "🇷🇪", "value": "+262"},
    {"label": "Romania", "iso": "RO", "flag": "🇷🇴", "value": "+40"},
    {"label": "Russia", "iso": "RU", "flag": "🇷🇺", "value": "+7"},
    {"label": "Rwanda", "iso": "RW", "flag": "🇷🇼", "value": "+250"},
    {"label": "Saint Barthelemy", "iso": "BL", "flag": "🇧🇱", "value": "+590"},
    {"label": "Saint Helena", "iso": "SH", "flag": "🇸🇭", "value": "+290"},
    {"label": "Saint Kitts and Nevis", "iso": "KN", "flag": "🇰🇳", "value": "+1-869"},
    {"label": "Saint Lucia", "iso": "LC", "flag": "🇱🇨", "value": "+1-758"},
    {"label": "Saint Martin", "iso": "MF", "flag": "🇲🇫", "value": "+590"},
    {"label": "Saint Pierre and Miquelon", "iso": "PM", "flag": "🇵🇲", "value": "+508"},
    {"label": "Saint Vincent and the Grenadines", "iso": "VC", "flag": "🇻🇨", "value": "+1-784"},
    {"label": "Samoa", "iso": "WS", "flag": "🇼🇸", "value": "+685"},
    {"label": "San Marino", "iso": "SM", "flag": "🇸🇲", "value": "+378"},
    {"label": "Sao Tome and Principe", "iso": "ST", "flag": "🇸🇹", "value": "+239"},
    {"label": "Saudi Arabia", "iso": "SA", "flag": "🇸🇦", "value": "+966"},
    {"label": "Senegal", "iso": "SN", "flag": "🇸🇳", "value": "+221"},
    {"label": "Serbia", "iso": "RS", "flag": "🇷🇸", "value": "+381"},
    {"label": "Seychelles", "iso": "SC", "flag": "🇸🇨", "value": "+248"},
    {"label": "Sierra Leone", "iso": "SL", "flag": "🇸🇱", "value": "+232"},
    {"label": "Singapore", "iso": "SG", "flag": "🇸🇬", "value": "+65"},
    {"label": "Sint Maarten", "iso": "SX", "flag": "🇸🇽", "value": "+599"},
    {"label": "Slovakia", "iso": "SK", "flag": "🇸🇰", "value": "+421"},
    {"label": "Slovenia", "iso": "SI", "flag": "🇸🇮", "value": "+386"},
    {"label": "Solomon Islands", "iso": "SB", "flag": "🇸🇧", "value": "+677"},
    {"label": "Somalia", "iso": "SO", "flag": "🇸🇴", "value": "+252"},
    {"label": "South Africa", "iso": "ZA", "flag": "🇿🇦", "value": "+27"},
    {"label": "South Georgia and the South Sandwich Islands", "iso": "GS", "flag": "🇬🇸", "value": "+500"},
    {"label": "South Korea", "iso": "KR", "flag": "🇰🇷", "value": "+82"},
    {"label": "South Sudan", "iso": "SS", "flag": "🇸🇸", "value": "+211"},
    {"label": "Spain", "iso": "ES", "flag": "🇪🇸", "value": "+34"},
    {"label": "Sri Lanka", "iso": "LK", "flag": "🇱🇰", "value": "+94"},
    {"label": "Sudan", "iso": "SD", "flag": "🇸🇩", "value": "+249"},
    {"label": "Surilabel", "iso": "SR", "flag": "🇸🇷", "value": "+597"},
    {"label": "Svalbard and Jan Mayen", "iso": "SJ", "flag": "🇸🇯", "value": "+47"},
    {"label": "Swaziland", "iso": "SZ", "flag": "🇸🇿", "value": "+268"},
    {"label": "Sweden", "iso": "SE", "flag": "🇸🇪", "value": "+46"},
    {"label": "Switzerland", "iso": "CH", "flag": "🇨🇭", "value": "+41"},
    {"label": "Syria", "iso": "SY", "flag": "🇸🇾", "value": "+963"},
    {"label": "Taiwan", "iso": "TW", "flag": "🇹🇼", "value": "+886"},
    {"label": "Tajikistan", "iso": "TJ", "flag": "🇹🇯", "value": "+992"},
    {"label": "Tanzania", "iso": "TZ", "flag": "🇹🇿", "value": "+255"},
    {"label": "Thailand", "iso": "TH", "flag": "🇹🇭", "value": "+66"},
    {"label": "Togo", "iso": "TG", "flag": "🇹🇬", "value": "+228"},
    {"label": "Tokelau", "iso": "TK", "flag": "🇹🇰", "value": "+690"},
    {"label": "Tonga", "iso": "TO", "flag": "🇹🇴", "value": "+676"},
    {"label": "Trinidad and Tobago", "iso": "TT", "flag": "🇹🇹", "value": "+1-868"},
    {"label": "Tunisia", "iso": "TN", "flag": "🇹🇳", "value": "+216"},
    {"label": "Turkey", "iso": "TR", "flag": "🇹🇷", "value": "+90"},
    {"label": "Turkmenistan", "iso": "TM", "flag": "🇹🇲", "value": "+993"},
    {"label": "Turks and Caicos Islands", "iso": "TC", "flag": "🇹🇨", "value": "+1-649"},
    {"label": "Tuvalu", "iso": "TV", "flag": "🇹🇻", "value": "+688"},
    {"label": "U.S. Virgin Islands", "iso": "VI", "flag": "🇻🇮", "value": "+1-340"},
    {"label": "Uganda", "iso": "UG", "flag": "🇺🇬", "value": "+256"},
    {"label": "Ukraine", "iso": "UA", "flag": "🇺🇦", "value": "+380"},
    {"label": "United Arab Emirates", "iso": "AE", "flag": "🇦🇪", "value": "+971"},
    {"label": "United Kingdom", "iso": "GB", "flag": "🇬🇧", "value": "+44"},
    {"label": "United States Minor Outlying Islands", "iso": "UM", "flag": "🇺🇲", "value": "+1"},
    {"label": "United States", "iso": "US", "flag": "🇺🇸", "value": "+1"},
    {"label": "Uruguay", "iso": "UY", "flag": "🇺🇾", "value": "+598"},
    {"label": "Uzbekistan", "iso": "UZ", "flag": "🇺🇿", "value": "+998"},
    {"label": "Vanuatu", "iso": "VU", "flag": "🇻🇺", "value": "+678"},
    {"label": "Vatican", "iso": "VA", "flag": "🇻🇦", "value": "+379"},
    {"label": "Venezuela", "iso": "VE", "flag": "🇻🇪", "value": "+58"},
    {"label": "Vietnam", "iso": "VN", "flag": "🇻🇳", "value": "+84"},
    {"label": "Wallis and Futuna", "iso": "WF", "flag": "🇼🇫", "value": "+681"},
    {"label": "Western Sahara", "iso": "EH", "flag": "🇪🇭", "value": "+212"},
    {"label": "Yemen", "iso": "YE", "flag": "🇾🇪", "value": "+967"},
    {"label": "Zambia", "iso": "ZM", "flag": "🇿🇲", "value": "+260"},
    {"label": "Zimbabwe", "iso": "ZW", "flag": "🇿🇼", "value": "+263"}
]